/* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2020, Bulb Inc. For more information, please email contact@hellobulb.com.
*          _
*  _            | | _
* | |         _ | || |
* | |__   _  | || || |__
* | '_ \ | | | || || '_ \
* | (_) || |_| || || (_) |
*  \___/  \___/ |_| \___/
*/

import { Directive, Inject } from '@angular/core';
import {
  AbstractControl, AsyncValidator, NG_ASYNC_VALIDATORS, ValidationErrors,
} from '@angular/forms';
import { Observable, of, timer } from 'rxjs';
import {
  delay, debounceTime, distinctUntilChanged, switchMap, map,
} from 'rxjs/operators';

/**
 * Custom validator that validates if the provided email is unique within bulb.
 */
@Directive({
  selector: '[bulbEmailUnique]',
  providers: [
    {
      provide: NG_ASYNC_VALIDATORS,
      useExisting: EmailUnique,
      multi: true,
    },
  ],
  standalone: false,
})
export class EmailUnique implements AsyncValidator {
  /**
   * Default Constructor.
   *
   * @param BulbAjaxService Our AngularJS Ajax Service.
   */
  constructor(@Inject('BulbAjaxService') private BulbAjaxService) {}

  /**
   * @inheritDoc
   *
   * @param control FormControl to validate, in this case the email address.
   * @returns null | ValidationErrors
   */
  validate(control: AbstractControl): Promise< ValidationErrors | null > | Observable< ValidationErrors | null > {
    if (!control.value) {
      return new Promise((resolve) => resolve(null));
    }
    return new Promise((resolve) => this.BulbAjaxService.validateField('emailUnique', control.value).then((data) => {
      if (!data.valid) {
        resolve({ customErrorCode: true, emailUnique: false, code: data.code });
      } else {
        resolve(null);
      }
    }));
  }
}
